import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "pages-service";

export default {
    getTermsAndCondition() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/pages/merchant/terms-and-conditions", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    // console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    },
    saveTermsAndCondition(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/pages/merchant/terms-and-conditions",
                param,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    },
    getTermsOfUse() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/pages/merchant/terms-of-use", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    // console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    },
    saveTermsOfUse(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/pages/merchant/terms-of-use", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    },
    getPrivacyPolicy() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/pages/merchant/privacy-policy", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    // console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    },
    savePrivacyPolicy(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/pages/merchant/privacy-policy",
                param,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    // console.log(error);
                    reject(status, error);
                });
        });
    }
};
